import React from 'react';
import { Shield, FileText, Zap, MapPin, Smartphone, Lock, CreditCard } from 'lucide-react';
import { Button } from './ui/Button';
import { Badge } from './ui/Badge';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative pt-8 pb-8 md:pt-32 md:pb-24 px-4 max-w-5xl mx-auto w-full flex flex-col items-center text-center overflow-hidden" data-id="element-80">
      <div className="absolute top-20 left-1/2 -translate-x-1/2 w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-blue-500/5 rounded-full blur-[100px] -z-10" data-id="element-81" />

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5
    }} className="flex items-center gap-1.5 text-blue-400 font-bold tracking-widest uppercase mb-4 md:mb-8 text-[10px] md:text-base" data-id="element-82">
        <Shield className="w-3.5 h-3.5 md:w-5 md:h-5" data-id="element-83" />
        DIGITALPREMIUM™
      </motion.div>

      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} className="md:text-6xl lg:text-7xl font-extrabold tracking-tight mb-4 md:mb-6 text-white text-[29px]" data-id="element-84">
        Protegé a tus hijos en el mundo digital.
        <br data-id="element-85" />
        <span className="text-brand-blue" data-id="element-86">Desde hoy.</span>
      </motion.h1>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.6,
      delay: 0.15
    }} className="w-full flex justify-center mb-6 md:mb-10" data-id="element-87">
        <div className="relative w-[280px] md:w-[420px] lg:w-[500px]" data-id="element-88">
          <img src="https://cdn.magicpatterns.com/uploads/1KKExGnqz8fVcbttYyGqVL/posta_-_Editado.png" alt="Mega Pack Protección Digital para Hijos - El pack más completo para padres" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-89" />
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.2
    }} className="max-w-2xl mx-auto space-y-3 md:space-y-6 mb-8 md:mb-10 px-2" data-id="element-90">
        <p className="md:text-2xl text-slate-300 font-medium text-[15px] leading-snug" data-id="element-91">
          Sistema Completo de Seguridad Digital para Padres — Práctico y Directo
        </p>
        <p className="text-[14px] md:text-lg text-slate-400 leading-relaxed" data-id="element-92">
          El recurso esencial para padres en Argentina que quieren entender,
          prevenir y actuar frente a los riesgos en redes sociales.
        </p>
        <p className="md:text-xl font-bold text-white text-[18px]" data-id="element-93">
          Sin vueltas. Sin teoría inútil. Sin improvisar.
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.3
    }} className="grid grid-cols-2 md:flex md:flex-wrap justify-center gap-2 md:gap-3 mb-10 md:mb-12 w-full max-w-[320px] md:max-w-none pr-[6px]" data-id="element-94">
        <Badge icon={<FileText className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-96" />} data-id="element-95">
          Formato PDF
        </Badge>
        <Badge icon={<Zap className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-98" />} data-id="element-97">
          Acceso en minutos
        </Badge>
        <Badge icon={<MapPin className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-100" />} data-id="element-99">
          Adaptado a Argentina
        </Badge>
        <Badge icon={<Smartphone className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-102" />} data-id="element-101">
          Aplicable desde el día 1
        </Badge>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }} className="w-full max-w-[340px] md:max-w-md flex flex-col items-center gap-4 md:gap-6" data-id="element-103">
        <Button fullWidth onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-104">
          QUIERO PROTEGER A MIS HIJOS AHORA
        </Button>

        <div className="flex items-center justify-center gap-3 md:gap-6 text-[11px] md:text-sm text-slate-400 font-medium" data-id="element-105">
          <span className="flex items-center gap-1" data-id="element-106">
            <Shield className="w-3.5 h-3.5 text-brand-blue" data-id="element-107" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1" data-id="element-108">
            <Lock className="w-3.5 h-3.5 text-brand-blue" data-id="element-109" /> Pago seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-110">
            <CreditCard className="w-3.5 h-3.5 text-brand-blue" data-id="element-111" /> Mercado Pago
          </span>
        </div>
      </motion.div>
    </section>;
}